export const isTheGamingClubs = window.location.hostname.includes('thegamingclubs')
//  || window.location.hostname.includes('localhost')
 ? true : false


// WEBPACK FOOTER //
// ./src/constants/isTheGamingClubs.js